export const API_BOOKING_LIST = 'https://invstaging.spacehero.gr/api/bookings'
export const API_UPDATE_INVENTORY = 'https://invstaging.spacehero.gr/api/update_inventory'
// export const API_BOOKING_LIST = 'http://localhost:9070/api/bookings'
// export const API_UPDATE_INVENTORY = 'http://localhost:9070/api/update_inventory'
